import { faCalendar, faSliders } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ShippingRulePresetApplication } from '../../models/ShippingRulePresetApplication';
import { useTranslation } from 'react-i18next';

interface HistoryCardProps {
  item: ShippingRulePresetApplication;
  className?: string;
}

const formatDate = (dateStr?: string) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Card mobile para historial de aplicaciones
export const HistoryCard = ({ item, className = '' }: HistoryCardProps) => {
  const { t } = useTranslation('shippingRulePresetsModule');
  const isSuccess = item.status === 'success';

  return (
    <div className={`py-4 border-b border-card-border ${className}`}>
      <div className="flex items-center justify-between gap-3 mb-2">
        <div className="min-w-0 flex items-center gap-2">
          <FontAwesomeIcon icon={faSliders} className="w-3.5 h-3.5 text-icons shrink-0" />
          <span className="text-sm font-semibold text-title truncate">{item.metadata?.preset_name || '-'}</span>
        </div>
        <span
          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
            isSuccess ? 'bg-bg-success text-bright-success' : 'bg-bg-error text-bright-error'
          }`}
        >
          {isSuccess ? t('history.status.success') : t('history.status.error')}
        </span>
      </div>

      <div className="flex flex-col gap-1 text-xs text-subtext">
        <span>
          {t('history.columns.targetTeam')}: {item.target_team?.name ?? '-'}
        </span>
        <span>
          {t('history.columns.appliedBy')}: {item.applied_by_user?.name ?? '-'}
        </span>
        <span className="flex items-center gap-1.5">
          <FontAwesomeIcon icon={faCalendar} className="w-3 h-3 text-icons" />
          {formatDate(item.applied_at)}
        </span>
        <span>
          {t('history.rulesInfo', {
            applied: item.rules_count,
            replaced: item.replaced_rules_count,
          })}
        </span>
      </div>
    </div>
  );
};
